import * as React from 'react';
import * as styles from './ErrorWrapper.css';

interface IErrorWrapperProps {
  children: React.ReactNode;
}

export const ErrorWrapper = ({ children }: IErrorWrapperProps) => {
  return (
    <>
      <div className={styles['background']} />
      <div className={styles['error']}>{children}</div>
    </>
  );
};
